import { useEffect, useState, useRef } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";

import { formatDate } from "../../helpers/helper";
import Loading from "../../components/Loading";
import Menu from "../../components/Menu";
import api from "../../services/api";

import { DefeitosTurma } from "../../components/Tabelas/DefeitosTurma";
import { useLocation, useNavigate } from "react-router";

const initialState = {
    turmas: [],
    producao_turmas: [],
    title: "",
    producao: "0",
    defeitos_sem_turma: 0
};

export function Defeito() {
    const location = useLocation();
    const navigate = useNavigate();

    const [data, setData] = useState({ ...initialState });
    const [isLoading, setIsLoading] = useState(false);
    const [initialDate, setInitialDate] = useState(location.state?.initialDate ?? new Date());
    const [finalDate, setFinalDate] = useState(location.state?.finalDate ?? new Date());

    const toast = useRef(null);

    const showError = (error) => {
        toast.current?.show({
            summary: 'Ocorreu um Erro',
            severity: 'error',
            detail: error.response ? error.response.data.message : error.message
        });
    };

    const handleSearch = _ => {
        setIsLoading(true);
        api.get("qualidade/premio", {
            params: {
                "data_inicial": formatDate(initialDate),
                "data_final": formatDate(finalDate)
            }
        }).then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }

    useEffect(() => {
        handleSearch();
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />

            <Card className="p-m-1">
                <Button
                    className="p-ml-1 p-button-secondary"
                    style={{marginTop: '-20px'}}
                    icon="pi pi-arrow-left"
                    label="Voltar"
                    onClick={() => {
                        navigate('/defeitos/premio', {
                            state: { initialDate, finalDate }
                        });
                    }}
                />
                <div className="p-d-flex p-flex-row">
                    <Calendar
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setInitialDate(e.value)}
                        placeholder="Selecione a Data Inicial"
                        value={initialDate}
                    />
                    <Calendar
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setFinalDate(e.value)}
                        placeholder="Selecione a Data Final"
                        value={finalDate}
                    />
                    <Button 
                        className="p-m-1"
                        icon="pi pi-search"
                        onClick={handleSearch}
                    />
                </div>
                <div>
                    <div className="p-mb-4 p-mt-3 p-pb-3" style={{ borderBottom: '2px solid #e9ecef' }}>
                        <h2 className="p-m-0" style={{ color: '#2c3e50', fontSize: '1.75rem' }}>
                            Relatório de Defeitos
                        </h2>
                        <span className="p-ml-1" style={{ color: '#7f8c8d', fontSize: '1.1rem', fontWeight: '500' }}>
                            {data.title}
                        </span>
                        <div className="p-mt-2 p-ml-1 p-d-flex p-flex-wrap">
                            <div style={{ backgroundColor: '#e3f2fd', color: '#0d47a1', padding: '0.5rem 1rem', borderRadius: '6px', border: '1px solid #bbdefb', textAlign: 'center' }}>
                                <span style={{ fontSize: '0.8rem', textTransform: 'uppercase', fontWeight: 'bold', display: 'block' }}>Produção Total</span>
                                <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{Intl.NumberFormat('pt-BR').format(data.producao)} m</span>
                            </div>
                        </div>
                    </div>

                    <DefeitosTurma turmas={data.turmas} producao_turmas={data.producao_turmas} titulo={data.title}/>
                </div>
            </Card>
        </div>
    );
}